import { trackOpenAICall } from '../../../lib/langsmith'

// Helper function to track successful analysis
export async function trackSuccessfulAnalysis(
  jobId: string,
  title: string,
  company: string,
  description: string,
  score: number,
  verdict: string | null,
  reasoning: string | null,
  analysisLatency: number
) {
  await trackOpenAICall(
    'analyze_job_relevance',
    {
      jobId,
      title,
      company,
      description: description.substring(0, 500) // Truncate for LangSmith
    },
    {
      score,
      verdict,
      reasoning
    },
    {
      latency: analysisLatency,
      timestamp: new Date().toISOString()
    }
  )
}

// Helper function to track failed analysis
export async function trackFailedAnalysis(
  jobId: string,
  title: string,
  company: string,
  description: string,
  errorMessage: string,
  analysisLatency: number
) {
  await trackOpenAICall(
    'analyze_job_relevance',
    {
      jobId,
      title,
      company,
      description: description ? description.substring(0, 500) : 'Description not loaded'
    },
    {
      score: null,
      verdict: null,
      reasoning: `Error: ${errorMessage}`
    },
    {
      latency: analysisLatency,
      timestamp: new Date().toISOString()
    }
  )
}
